<template>
  <div class="page-container">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#" class="active">{{ $t("stock") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="main-card">
      <div class="body-grid">
        
        <div class="part">
          <h6>{{ $t("sales") }} / {{ $t("purchases") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/stock/AllBuyAndSell">
                {{ $t("reports") }} {{ $t("purchases") }} {{ $t("and") }} {{ $t("sales") }}
              </router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/stock/AllBuyAndSellP">
                {{ $t("summary") }} {{ $t("invoices") }} {{ $t("sales") }} {{ $t("and") }} {{ $t("purchases") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="part">
          <h6>{{ $t("products") }} & {{ $t("item") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/stock/StockBalance">
                {{ $t("balance") }} {{ $t("stock") }} {{ $t("from") }} {{ $t("products") }}
              </router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/stock/ProductStockBalance">
                {{ $t("transactions") }} {{ $t("stock") }} {{ $t("from") }} {{ $t("product") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="part">
          <h6>{{ $t("products") }} & {{ $t("damaged") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/stock/damagedproducts">
                {{ $t("damaged") }} {{ $t("products") }}
              </router-link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
  title: "Stock",
  props: ["css"],
  data() {
    return {
      costomer: 0,
      suppliers: 0,
      invoices: 0,
      bills: 0,
      salles: "",
      loading: false
    };
  },
  async created() {
    try {
      this.loading = true;
      const result = await axios.get(`/reports/homesummary`);
      if (result.status === 200) {
        this.costomer = result.data.customer[0]?.count || 0;
        this.suppliers = result.data.suppliers[0]?.count || 0;
        this.invoices = result.data.invoice[0]?.count || 0;
        this.bills = result.data.bills[0]?.count || 0;
        this.salles = result.data.salles;
      }
    } catch (error) {
      console.error("Error executing background metrics update:", error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions(["redirectTo"]),
  },
};
</script>

<style lang="scss" scoped>
/* Reset and Container Basics */
.page-container {
  direction: v-bind("css.EN");
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.breadcrumb {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  
  li a {
    text-decoration: none;
    font-weight: 600;
    font-size: 1.2rem;
    color: #333;
    
    &.active {
      color: v-bind("css.color");
    }
  }
}

/* Main Dashboard Card Wrapper */
.main-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
}

/* Bottom Navigation Grid System */
.body-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;
}

.part {
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  align-self: start;

  h6 {
    font-size: 16px;
    font-weight: 700;
    color: #1a202c;
    margin-top: 0;
    margin-bottom: 16px;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 8px;
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .bi-three-dots-vertical {
        color: #a0aec0;
        margin-right: 8px;
        font-size: 14px;
      }

      a {
        color: #4a5568;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: v-bind("css.color");
          font-weight: 500;
        }
      }
    }
  }
}

/* Responsive Breakpoints */
@media screen and (max-width: 992px) {
  .body-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 576px) {
  .page-container {
    padding: 10px;
  }
  
  .main-card {
    padding: 16px;
  }

  .body-grid {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
  
  .part {
    padding: 16px;
    
    h6 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    
    ul li {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}
</style>